import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetTerminationTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const terminationTypes = useQuery(
    ['getTerminationTypes'],
    async () => {
      return await handleRequest(ParticipantService.getApiAwardApiAppParticipantTerminationTypes());
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return terminationTypes;
};

export default useGetTerminationTypes;
